module.exports = __webpack_public_path__ + "static/media/trash-disable.a74a10d7.svg";